// Partner strip on the Home page: shows partner logos in a looping row.

import "../../styles/Home.css";

function PartnerPills({ partners }) {
  // Loop the partners array 2 times to create a seamless scrolling effect
  const loopedPartners = [...partners, ...partners]; 

  return (
    <div className="partnerPills">
      <div className="partnerPills__track">
        {loopedPartners.map((p, index) => (
          <div
            key={`${p.name}-${index}`}
            className="partnerPills__pill"
          >
            <img
              src={p.logo || p.log}
              alt={p.name}
              className="partnerPills__logo"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default PartnerPills;
